export class BillingDetails {
  vat: string;
  businessName: string;
  address: string;
  city: number;
  country: number;
}
